export const INPUT_NAMES = {
  name: 'nameRef',
  position: 'positionRef',
  email: 'emailRef',
  role: 'roleRef',
  organization: 'organizationRef',
} as const
